import styled from '@emotion/styled';
import { FormControl, Paper, Popper, TextField, Typography } from '@material-ui/core';
import { Autocomplete } from '@material-ui/lab';
import { createElement, FC } from 'react';
import { FormattedMessage } from 'react-intl';

import { OrganizationDetailFragment } from '../../../../generated/graphql';

export interface Props {
  availableOrganizations: Array<OrganizationDetailFragment>;
  selectedOrganization: OrganizationDetailFragment;
  onChange: (organization: OrganizationDetailFragment) => void;
  className?: string;
}

const OrganizationSelector: FC<Props> = ({ availableOrganizations, selectedOrganization, onChange, className }) => {
  const organizations = availableOrganizations;

  const handleChangeOrganization = (key: string) => {
    const targetOrganization = organizations.find((organization) => organization.id === key);
    targetOrganization
      ? onChange(targetOrganization)
      : () => {
          throw new Error('selected organization not found');
        };
  };

  return (
    <FormControl className={className}>
      <Autocomplete
        blurOnSelect
        autoHighlight
        autoComplete
        openOnFocus
        fullWidth
        disableClearable
        options={organizations}
        value={selectedOrganization}
        noOptionsText={
          <Typography>
            <FormattedMessage id={'choose_organization.no_results'} />
          </Typography>
        }
        getOptionLabel={(option) => option.name}
        renderOption={(option) => <OrganizationOptionItem>{option.name}</OrganizationOptionItem>}
        renderInput={(params) => (
          <TextField {...params} margin="normal" inputProps={{ ...params.inputProps, style: { fontSize: 14 } }} />
        )}
        onChange={(_, props) => {
          _ && props && handleChangeOrganization(props.id);
        }}
        onKeyDown={(event: any) => {
          // 方向キーがPopperを閉じてしまう挙動をなくした
          event.stopPropagation();
        }}
        PopperComponent={(props) => <Popper {...props} placement="top" />}
        PaperComponent={StyledPaper}
      />
    </FormControl>
  );
};

const StyledPaper = styled(Paper)({
  width: 360,
  height: '100%',
  maxHeight: '70vh',
  overflowY: 'auto',
  '.MuiAutocomplete-listbox': {
    maxHeight: '100%',
  },
});

const OrganizationOptionItem = styled(Typography)({
  height: 'auto',
  whiteSpace: 'initial',
  overflowWrap: 'break-word',
  width: '100%',
});

export default OrganizationSelector;
